var _g;
import * as React from "react";
var SvgYoutubePlay = function SvgYoutubePlay(props) {
  return _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.6963;fill-rule:evenodd;clip-rule:evenodd;enable-background:new    ;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t#youtube-icon-svg:hover #youtube-icon-backround { fill: #F91A12 }\n"), /*#__PURE__*/React.createElement("g", {
    id: "youtube-icon-svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "youtube-icon-backround",
    className: "st0",
    d: "M60.5671,1.4592C55.2643,0,34,0,34,0S12.7357,0,7.4329,1.4592C4.5073,2.262,2.203,4.6278,1.421,7.632 C0,13.0768,0,24.4375,0,24.4375S0,35.7978,1.421,41.243c0.782,3.0042,3.0863,5.3699,6.0118,6.1732 C12.7357,48.875,34,48.875,34,48.875s21.2643,0,26.5671-1.4588c2.9255-0.8033,5.2298-3.169,6.0118-6.1732 C68,35.7978,68,24.4375,68,24.4375s0-11.3607-1.421-16.8055C65.797,4.6278,63.4927,2.262,60.5671,1.4592z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "youtube-icon-arrow",
    className: "st1",
    points: "27.0455,34.7521 27.0455,14.1229 44.8182,24.4379 "
  })));
};
export default SvgYoutubePlay;